// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"8e481e43","405":"63259e05","453":"48fe9e67"}[chunkId] + ".chunk.js";
};